<template>
    <div class="tw-p-5 tw-bg-gray-50">
        <div class="tw-grid tw-grid-cols-3 tw-gap-4">
            <l-meeting-analytics-distribution-chart
                class="tw-col-span-3 tw-bg-white tw-p-4 tw-rounded-md"
                :height="150"
                :timelines="user.timelines"
                :time-unit="timeUnit"
            />

            <div
                v-for="meeting in user.meetings"
                :key="`${user._id}_${meeting._id}`"
                class="tw-col-span-3 xl:tw-col-span-1 tw-bg-white tw-p-6 tw-rounded-md"
            >
                <div class="tw-flex tw-items-center tw-justify-between tw-space-x-6">
                    <div class="tw-flex-1">
                        <div class="tw-text-gray-900 tw-text-sm tw-font-semibold truncate-3">
                            {{ meeting.latestTitle || "N/A" }}
                        </div>
                        <div
                            class="tw-text-gray-500 tw-text-sm"
                            :title="meeting.latestOccurrence | moment('MMM DD, YYYY - HH:mm')"
                        >
                            {{ $moment(meeting.latestOccurrence).fromNow() }}
                        </div>
                        <div class="tw-flex tw-flex-wrap tw--space-x-1 tw-mt-4">
                            <l-profile-picture
                                v-for="participant in limitParticipantListing(
                                    meeting.latestParticipants,
                                )"
                                :key="`${user._id}_${meeting._id}_${participant._id}`"
                                size="xs"
                                :user="participant"
                                :show-popover-name="true"
                                class="tw-inline-block"
                                img-classes="tw-ring-2 tw-ring-white"
                            />
                        </div>
                        <span
                            v-if="
                                meeting.latestParticipants &&
                                    meeting.latestParticipants.length > maxParticipantsVisible
                            "
                            class="tw-text-xs tw-text-gray-400"
                        >
                            {{
                                $t("meetings.analytics.userlist.moreParticipants", [
                                    meeting.latestParticipants.length - maxParticipantsVisible,
                                ])
                            }}
                        </span>
                    </div>
                    <div class="tw-flex-shrink-0 tw-leading-none tw-text-gray-600 tw-text-right">
                        {{ meeting.amountTotal }}x<br />
                        <span class="tw-mt-1 tw-text-xs tw-text-gray-400">{{
                            $t("meetings.analytics.userlist.scheduled")
                        }}</span>
                        <div class="tw-mt-4">
                            {{ meeting.amountLikelyHeld }}x<br />
                            <span class="tw-mt-1 tw-text-xs tw-text-gray-400">{{
                                $t("meetings.analytics.userlist.withActivity")
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LMeetingAnalyticsDistributionChart from "@/components/LMeetingAnalytics/LMeetingAnalyticsDistributionChart";
import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: {
        LMeetingAnalyticsDistributionChart,
        LProfilePicture,
    },
    props: {
        timeUnit: {
            type: String,
            default: "month",
        },
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            maxParticipantsVisible: 20,
        };
    },
    methods: {
        limitParticipantListing(list = []) {
            if (!Array.isArray(list)) return [];

            return list.slice(0, this.maxParticipantsVisible);
        },
    },
};
</script>

<style scoped>
.truncate-3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 3;
}

.bootstrap-override {
    border-right: none !important;
    border-left: none !important;
}
</style>
